import Component from './AssociatedEntitiesTable';
import createRenderer from './AssociatedEntitiesTable.relay';
export default createRenderer(Component);



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/AssociatedEntitiesTable/index.js